import AlertNameFacet from './AlertNameFacet/AlertNameFacet';
import AlertTriggeredFacet from './AlertTriggeredFacet/AlertTriggeredFacet';
import AlertTagsFacet from './AlertTagsFacet/AlertTagsFacet';
import ChannelTypeFacet from './ChannelTypeFacet/ChannelTypeFacet';
import PushStatusFacet from './PushStatusFacet/PushStatusFacet';
import DeviceTagsFacet from './DeviceTagsFacet/DeviceTagsFacet';
import AlertFavoriteFacet from './AlertFavoriteFacet/AlertFavoriteFacet';
import HistoricalAlertEventFacet from './HistoricalAlertEventFacet/HistoricalAlertEventFacet';
import AlertSuspendedFacet from './AlertSuspendedFacet/AlertSuspendedFacet';
import AlertThresholdFacet from './AlertThresholdsFacet/AlertThresholdsFacet';
import FacetType from '../../utility/types/facetType';
import BaseFacet from './BaseFacet/BaseFacet';
import AlertAcknowledgedFacet from './AlertAcknowledgedFacet/AlertAcknowledgedFacet';
import DeviceSuspendedFacet from './DeviceSuspendedFacet/DeviceSuspendedFacet';
import DeviceNameFacet from './DeviceNameFacet/DeviceNameFacet';
import DeviceFirmwareStatusFacet from './DeviceFirmwareStatusFacet/DeviceFirmwareStatusFacet';
import DeviceLinkConnectionFacet from './DeviceLinkConnectionFacet/DeviceLinkConnectionFacet';
import DeviceTypeFacet from './DeviceTypeFacet/DeviceTypeFacet';
import AlertQuietTimeFacet from './AlertQuietTimeFacet/AlertQuietTimeFacet';
import ChannelGroupNameFacet from './ChannelGroupNameFacet/ChannelGroupNameFacet';
import ChannelLastReadingTimestampFacet from './ChannelLastReadingTimestampFacet/ChannelLastReadingTimestampFacet';
import ChannelAlertCountFacet from './ChannelAlertCountFacet/ChannelAlertCountFacet';
import NotificationTemplateFacet from './NotificationTemplateFacet/NotificationTemplateFacet';
import NotificationGroupFacet from './NotificationGroupFacet/NotificationGroupFacet';

export const FacetClasses = {
  [FacetType.ALERT_NAME]: AlertNameFacet,
  [FacetType.ALERT_TRIGGERED]: AlertTriggeredFacet,
  [FacetType.ALERT_TAGS]: AlertTagsFacet,
  [FacetType.CHANNEL_TYPE]: ChannelTypeFacet,
  [FacetType.PUSH_STATUS]: PushStatusFacet,
  [FacetType.DEVICE_TAGS]: DeviceTagsFacet,
  [FacetType.ALERT_FAVORITE]: AlertFavoriteFacet,
  [FacetType.HISTORICAL_ALERT_EVENT]: HistoricalAlertEventFacet,
  [FacetType.NOTIFICATION_GROUP]: NotificationGroupFacet,
  [FacetType.ALERT_SUSPENDED]: AlertSuspendedFacet,
  [FacetType.THRESHOLD]: AlertThresholdFacet,
  [FacetType.ALERT_ACKNOWLEDGED]: AlertAcknowledgedFacet,
  [FacetType.DEVICE_SUSPENDED]: DeviceSuspendedFacet,
  [FacetType.DEVICE_NAME]: DeviceNameFacet,
  [FacetType.DEVICE_TYPE]: DeviceTypeFacet,
  [FacetType.DEVICE_FIRMWARE_STATUS]: DeviceFirmwareStatusFacet,
  [FacetType.DEVICE_LINK_CONNECTION]: DeviceLinkConnectionFacet,
  [FacetType.ALERT_QUIET_TIME]: AlertQuietTimeFacet,
  [FacetType.ALERT_NOTIFICATION_TEMPLATES]: NotificationTemplateFacet,
  [FacetType.CHANNEL_GROUP_NAME]: ChannelGroupNameFacet,
  [FacetType.CHANNEL_LAST_READING_TIMESTAMP]: ChannelLastReadingTimestampFacet,
  // [FacetType.CHANNEL_LAST_READING_VALUE_COMPARISON]: ChannelLastReadingValueComparison,
  [FacetType.CHANNEL_ALERT_COUNT]: ChannelAlertCountFacet,
  // [FacetType.SENSOR_PORT]: SensorPortFacet,
};

export default function createFacet(type) {
  const FacetClass = FacetClasses[type];
  if (!FacetClass) {
    return new BaseFacet();
  }

  return new FacetClass();
}
